import { useEffect, useState } from "react";

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <footer className="w-full bg-accent-100/80 py-12 md:py-16" aria-label="页脚">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid gap-10 md:grid-cols-4">
            <div className="md:col-span-1">
              <a href="#top" className="flex items-center gap-2.5" aria-label="大瓜网 返回顶部">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                  <i className="ri-water-flash-line text-xl" aria-hidden="true" />
                </span>
                <span className="font-display text-2xl text-foreground-950">大瓜网</span>
              </a>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                全网热瓜的围观现场，评论区热议、吃瓜群众观点实时汇聚。看瓜也看人，各路看法都在这里碰撞。
              </p>
              <div className="mt-5 flex gap-2">
                {["ri-wechat-fill", "ri-weibo-fill", "ri-tiktok-line", "ri-douban-line"].map((i) => (
                  <a
                    key={i}
                    href="#top"
                    aria-label="社交平台入口"
                    className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-lg text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={i} aria-hidden="true" />
                  </a>
                ))}
              </div>
            </div>

            <div className="md:col-span-1">
              <h3 className="text-sm font-bold text-foreground-950">热门板块</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
                {["影视综艺", "社会热点", "娱乐八卦", "科技互联网", "生活趣闻", "体育电竞"].map((n) => (
                  <li key={n}>
                    <a href="#forum" className="transition-colors hover:text-primary-600">
                      {n}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-1">
              <h3 className="text-sm font-bold text-foreground-950">快速入口</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
                <li><a href="#hot" className="transition-colors hover:text-primary-600">头条热帖</a></li>
                <li><a href="#trend" className="transition-colors hover:text-primary-600">热搜话题榜</a></li>
                <li><a href="#thread" className="transition-colors hover:text-primary-600">瓜友热议</a></li>
                <li><a href="#faq" className="transition-colors hover:text-primary-600">吃瓜常见问题</a></li>
              </ul>
            </div>

            <div className="md:col-span-1">
              <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-600" aria-hidden="true" />
                  <a href="mailto:hello@dagua.example.com" className="transition-colors hover:text-primary-600">
                    hello@dagua.example.com
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-600" aria-hidden="true" />
                  内容审核 7×24 小时在线
                </li>
              </ul>
              <a
                href="mailto:hello@dagua.example.com"
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
              >
                反馈与建议
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-foreground-950/10 pt-6 sm:flex-row">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} 大瓜网 · 理性吃瓜，文明讨论。本站内容均来自公开讨论，仅供参考。
            </p>
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-700" aria-hidden="true" />
              内容自律 · 共建友好社区氛围
            </div>
          </div>
        </div>
      </footer>

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-soft transition-colors hover:bg-primary-600"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
        </button>
      )}
    </>
  );
}